import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-start-screen',
  templateUrl: './start-screen.component.html',
  styleUrls: ['./start-screen.component.scss']
})
export class StartScreenComponent implements OnInit {
  game;
  bgColor;

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private router: Router, private http: HttpClient) { }

  navigateBack() {
    this.router.navigate(['/']);
  }

  getGame(gameId, player){
    return this.http.post(environment.baseUrl + 'games/getGame', {gameId, player} ).subscribe((data: any) => {
     if(data.success){
       this.game = data.data;
       // Only use custom colors if white label is enabled
       if (this.game.partner?.isWhiteLabel) {
         // White label enabled - check for custom branding, then partner color, fallback to purple
         this.bgColor = (this.game.tourId?.isCustomBranding && this.game.tourId.customBranding?.color) 
           ? this.game.tourId.customBranding.color 
           : (this.game.partner?.color || '#4e3b74');
       } else {
         // Not white label - always use Flinkit purple
         this.bgColor = '#4e3b74';
       }

       console.log('af', this.game)
     }
   }); 
 }

 getFormattedText(string){
  return this.sanitizer.bypassSecurityTrustHtml(string);
}

 jumpToGame(){
  this.http.post(environment.baseUrl + 'games/addStartedDate', { gameId: this.route.snapshot.paramMap.get('g') }).subscribe((data: any) => {
    if (data.success) {
      this.router.navigate(['/game', {g: this.route.snapshot.paramMap.get('g'), p: this.route.snapshot.paramMap.get('p'), showcase: this.route.snapshot.paramMap.get('showcase') }]);
    } else {
      console.log('started date not added');
    }
  });
 }

  ngOnInit(): void {
    if (!this.route.snapshot.paramMap.get('g') || !this.route.snapshot.paramMap.get('p')) {
      this.navigateBack();
    } 
    if(this.route.snapshot.paramMap.get('g') && this.route.snapshot.paramMap.get('p')){
      this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'))
    }
   
  }

}
